var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61538 1H3.46154C3.13512 1 2.82207 1.12967 2.59125 1.36048C2.36044 1.5913 2.23077 1.90435 2.23077 2.23077V13.3077L1 17L5.92308 15.7692H15.7692C16.0957 15.7692 16.4087 15.6396 16.6395 15.4087C16.8703 15.1779 17 14.8649 17 14.5385V8.38462",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6777 10.3994L6.98535 11.064L7.60074 7.32251L13.4223 1.52559C13.5366 1.41008 13.6727 1.31839 13.8227 1.25581C13.9727 1.19323 14.1336 1.16101 14.2961 1.16101C14.4586 1.16101 14.6196 1.19323 14.7695 1.25581C14.9195 1.31839 15.0556 1.41008 15.17 1.52559L16.4746 2.8302C16.5898 2.9447 16.6812 3.08085 16.7436 3.23082C16.806 3.38079 16.8381 3.54162 16.8381 3.70405C16.8381 3.86648 16.806 4.02731 16.7436 4.17728C16.6812 4.32724 16.5898 4.4634 16.4746 4.5779L10.6777 10.3994Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastBlog);
export default __webpack_public_path__ + "static/media/toast-blog.565bb185c86b65a5f2934477c7923566.svg";
export { ForwardRef as ReactComponent };